import { createContext } from 'react';
import type { CloseDialog, OpenDialog } from '../Dialog.interface';

export const DialogsContext = createContext<{
  open: OpenDialog;
  close: CloseDialog;
} | null>(null);
